module.exports = __webpack_public_path__ + "static/media/left_arrow.41de6b65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/left_arrow.svg
// module id = 1610
// module chunks = 0